import { RewardsRoutes } from '../navigation/routes'
import { RewardsComponents } from '../components'
import { TRANSITION_TO_SPLIT_SCREEN_WIDTH } from '../types'
import { mesaColorNames, typography } from '@/src/common/theme'
import { useMediaQuery } from 'react-responsive'
import { usePoints } from '@/src/common/hooks/usePoints'
import { DesignSystem } from '@/src/design-system'
import { View, Text, StyleSheet } from 'react-native'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { Link } from 'expo-router'
// Refer a Friend temporarily hidden - see https://mesamember.slack.com/archives/C07JK5U3H8S/p1764867423105289
// import { ReferAFriendButton } from '@/src/common/components/Referrals/ReferAFriendButton'
import { RewardsE2E } from '../e2e'
// import { useSourcePartnerName } from '@/src/common/hooks/useSourcePartnerName'

const styles = StyleSheet.create({
  screen: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    flex: 1,
    flexDirection: 'column',
  },
  headerCard: { flex: 1 },
  headerCardTop: {
    paddingHorizontal: 16,
    paddingVertical: 32,
    justifyContent: 'center',
  },
  cardContent: {
    gap: 16,
  },
  cardTitle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: typography['heading/heading3'],
  description: typography['paragraph/sm'],
})

export function BalanceHeaderCard() {
  const isSplitScreen = useMediaQuery({ minWidth: TRANSITION_TO_SPLIT_SCREEN_WIDTH })
  const balanceData = usePoints().query.data
  // const { sourcePartnerName } = useSourcePartnerName()

  return (
    <Link href={RewardsRoutes.PointsLedger.route} asChild>
      <DesignSystem.SplitCard style={styles.headerCard}>
        <DesignSystem.SplitCard.Header
          containerStyle={[styles.headerCardTop, isSplitScreen && { height: 200 }]}
        >
          <RewardsComponents.BalanceHeader
            currentPoints={balanceData?.getPointsBalance.active.value}
            lifetimeEarnedPoints={balanceData?.getPointsBalance.lifetimeEarned.value}
            lifetimeRedeemedPoints={balanceData?.getPointsBalance.lifetimeSpent.value}
            view="compact"
          />
        </DesignSystem.SplitCard.Header>
        <DesignSystem.SplitCard.Content style={styles.cardContent}>
          <View style={styles.cardTitle} testID={RewardsE2E.Ids.Press.PointsLedger}>
            <Text style={styles.title}>Mesa Points Summary</Text>
            <ChevronRight />
          </View>
          <Text style={styles.description}>
            Track your Mesa Point activity, including earnings and redemptions, in one place.
          </Text>
        </DesignSystem.SplitCard.Content>
      </DesignSystem.SplitCard>
    </Link>
  )
}
